import styled from 'styled-components';
import {commonPalette} from '../../styles/palette';
import {Button} from '../Button';
import $Icon from '../Icon';

export const ResetPasswordForm = styled.form`
  ${({isMobile}) => (isMobile ? 'margin: 0' : 'margin: 15px 100px 15px;')};
  ${({isMobile}) => (isMobile ? 'width: 343px' : 'width: 428px;')};
  height: 335px;
`;

export const Title = styled.div`
  text-align: ${({isMobile}) => (isMobile ? 'left' : 'center')};
  font-size: ${({isMobile}) => (isMobile ? '20px' : '24px')};
  margin-bottom: ${({isMobile}) => (isMobile ? '15px' : '40px')};
  color: ${commonPalette.txBlack};
  font-weight: ${({isMobile}) => (isMobile ? '400' : '600')};
  line-height: ${({isMobile}) => (isMobile ? '30px' : '32px')};
`;

export const StyledDiv = styled.div`
  widht: 428px;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: ${({margin}) => (margin ? margin : '10px')};
  text-align: ${({alignText}) => (alignText ? alignText : 'left')};
  color: #333330;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin: 15px 0 10px 0;
`;

export const StyledText = styled.div`
  color: ${commonPalette.textBrand};
  margin: 10px 0;
  text-align: ${({alignText}) => (alignText ? alignText : 'center')};
  font-size: 14px;
`;

export const StyledIcon = styled($Icon).attrs({})`
  width: 16px;
  height: 90%;
  margin-bottom: 3px;
  margin-right: 2px;
`;

export const ErrorNotification = styled.div`
  color: #f31414;
  font-size: 14px;
  font-family: lato;
  padding: 10px 2px;
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  margin-top: 5px;
`;

export const StyledErrorIcon = styled($Icon).attrs({})`
  width: 16px;
  color: #f31414;
  display: inline-block;
  margin-top: 7px;
`;

export const getHeight = () => ({
  height: '56px',
  padding: '0px 40px 0px 16px'
});

export const StyledButtonLink = styled.a`
  color: ${commonPalette.textBrand};
  &:hover {
    color: ${commonPalette.textBrand};
  }
`;
